import { render, staticRenderFns } from "./PinterestFollow.vue?vue&type=template&id=2aca3816&"
import script from "./PinterestFollow.vue?vue&type=script&lang=ts&"
export * from "./PinterestFollow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports